<template>
  <!--Container-->
  <div class="container px-4 md:px-0 max-w-6xl mx-auto -mt-32">
    <div class="mx-0 sm:mx-6">
      <div class="bg-indigo-900 text-center py-4 lg:px-4" href="#subscribe">
        <div
          class="p-2 bg-indigo-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
          role="alert"
        >
          <span
            class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3"
            >New</span
          >
          <span class="font-semibold mr-2 text-left flex-auto"
            >Get the coolest t-shirts from our brand new store</span
          >
          <svg
            class="fill-current opacity-75 h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"
            />
          </svg>
        </div>
      </div>
      <!--Nav-->
      <!-- <nav class="mt-0 w-full">
        <div class="container mx-auto flex items-center">
          <div class="flex w-1/2 pl-4 text-sm">
            <ul class="list-reset flex justify-between flex-1 md:flex-none items-center">
              <li class="mr-2">
                <a class="inline-block py-2 px-2 text-white no-underline hover:underline">POST</a>
              </li>
              <li class="mr-2">
                <a
                  class="inline-block text-gray-600 no-underline hover:text-gray-200 hover:underline py-2 px-2"
                >LINK</a>
              </li>
              <li class="mr-2">
                <a
                  class="inline-block text-gray-600 no-underline hover:text-gray-200 hover:underline py-2 px-2"
                >LINK</a>
              </li>
              <li class="mr-2">
                <a
                  class="inline-block text-gray-600 no-underline hover:text-gray-200 hover:underline py-2 px-2"
                >POST_VUE</a>
              </li>
            </ul>
          </div>

          <div class="flex w-1/2 justify-end content-center">
            <a
              class="inline-block text-gray-500 no-underline hover:text-white hover:text-underline text-center h-10 p-2 md:h-auto md:p-4 avatar"
              data-tippy-content="@twitter_handle"
              href="https://twitter.com/intent/tweet?url=#"
            >
              <svg class="fill-current h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <path
                  d="M30.063 7.313c-.813 1.125-1.75 2.125-2.875 2.938v.75c0 1.563-.188 3.125-.688 4.625a15.088 15.088 0 0 1-2.063 4.438c-.875 1.438-2 2.688-3.25 3.813a15.015 15.015 0 0 1-4.625 2.563c-1.813.688-3.75 1-5.75 1-3.25 0-6.188-.875-8.875-2.625.438.063.875.125 1.375.125 2.688 0 5.063-.875 7.188-2.5-1.25 0-2.375-.375-3.375-1.125s-1.688-1.688-2.063-2.875c.438.063.813.125 1.125.125.5 0 1-.063 1.5-.25-1.313-.25-2.438-.938-3.313-1.938a5.673 5.673 0 0 1-1.313-3.688v-.063c.813.438 1.688.688 2.625.688a5.228 5.228 0 0 1-1.875-2c-.5-.875-.688-1.813-.688-2.75 0-1.063.25-2.063.75-2.938 1.438 1.75 3.188 3.188 5.25 4.25s4.313 1.688 6.688 1.813a5.579 5.579 0 0 1 1.5-5.438c1.125-1.125 2.5-1.688 4.125-1.688s3.063.625 4.188 1.813a11.48 11.48 0 0 0 3.688-1.375c-.438 1.375-1.313 2.438-2.563 3.188 1.125-.125 2.188-.438 3.313-.875z"
                />
              </svg>
            </a>
            <a
              class="inline-block text-gray-500 no-underline hover:text-white hover:text-underline text-center h-10 p-2 md:h-auto md:p-4 avatar"
              data-tippy-content="#facebook_id"
              href="https://www.facebook.com/sharer/sharer.php?u=#"
            >
              <svg class="fill-current h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <path
                  d="M19 6h5V0h-5c-3.86 0-7 3.14-7 7v3H8v6h4v16h6V16h5l1-6h-6V7c0-.542.458-1 1-1z"
                />
              </svg>
            </a>
          </div>
        </div>
      </nav>-->

      <div
        class="bg-gray-200 w-full text-xl md:text-2xl text-gray-800 leading-normal rounded-t"
      >
        <!--Lead Card-->
        <div class="flex h-full bg-white rounded overflow-hidden shadow-lg">
          <a href class="flex flex-wrap no-underline hover:no-underline">
            <div class="w-full md:w-2/3 rounded-t">
              <img
                src="../assets/ducky_cn_tower.jpg"
                class="h-full w-full shadow"
              />
            </div>

            <div class="w-full md:w-1/3 flex flex-col flex-grow flex-shrink">
              <div
                class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg"
              >
                <p class="w-full text-gray-600 text-xs md:text-sm pt-6 px-6">
                  WELCOME
                </p>
                <div class="w-full font-bold text-xl text-gray-900 px-6">
                  👋 This is Ducky's World. Find out all about me here!
                </div>
                <hr />
                <p class="text-gray-800 font-serif text-base px-6 mb-5">
                  My name is ducky and I'm a big boy! I live with my mom and dad
                  in Toronto, ON.
                </p>

                <p class="text-gray-800 font-serif text-base px-6 mb-5">
                  You can follow me on Instagram -
                  <a href="https://instagram.com/thelifeofducky"
                    >@thelifeofducky</a
                  >.
                </p>

                <p class="text-gray-800 font-serif text-base px-6 mb-5">
                  Please subscribe to my mailing list below to stay up to date
                  with everything that I'm doing. I will send you an email
                  whenever there is something new.
                </p>

                <p class="text-gray-800 font-serif text-base px-6 mb-5">
                  Check back soon! We will be launching our brand new store with
                  cool stuff that you can buy! P.S: I like video games!
                </p>
              </div>

              <div
                class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6"
              >
                <!-- <div class="flex items-center justify-between">
                  <img
                    class="w-8 h-8 rounded-full mr-4 avatar"
                    data-tippy-content="Author Name"
                    src="http://i.pravatar.cc/300"
                    alt="Avatar of Author"
                  />
                  <p class="text-gray-600 text-xs md:text-sm">1 MIN READ</p>
                </div>-->
              </div>
            </div>
          </a>
        </div>
        <!--/Lead Card-->

        <!-- <vue-instagram
          token="5a8bd1cf1d914d989f98ad7050c24eb0"
          :count="5"
          :tags="['hashtag1', 'hashtag2']"
          mediaType="image"
        >
          <template slot="feeds" slot-scope="props">
            <li class="fancy-list">{{ props.feed.link }}</li>
          </template>
          <template slot="error" slot-scope="props">
            <div class="fancy-alert">{{ props.error.error_message }}</div>
          </template>
        </vue-instagram>-->
      </div>

      <Subscribe />

      <!--Author-->
      <div class="flex w-full items-center font-sans p-8 md:p-24">
        <img
          class="w-10 h-10 rounded-full mr-4"
          src="../assets/ducky_cn_tower.jpg"
          alt="Avatar of Author"
        />
        <div class="flex-1">
          <p class="text-base font-bold text-base md:text-xl leading-none">
            Ducky
          </p>
          <p class="text-gray-600 text-xs md:text-base">
            I'm a big boy. Follow me on Instagram
            <a
              class="text-gray-800 hover:text-teal-500 no-underline border-b-2 border-teal-500"
              href="https://www.instagram.com/thelifeofducky"
              >@thelifeofducky</a
            >
          </p>
        </div>
        <div class="justify-end">
          <!-- <button
            class="bg-transparent border border-gray-500 hover:border-teal-500 text-xs text-gray-500 hover:text-teal-500 font-bold py-2 px-4 rounded-full"
          >Read More</button>-->
        </div>
      </div>
      <!--/Author-->
    </div>
  </div>
</template>

<script>
import Subscribe from "@/components/Subscribe";

export default {
  name: "Hero",
  components: {
    Subscribe
  }
};
</script>
